 //const baseUrl = "https://localhost:7058/api"; 
const baseUrl = "https://apps.genus.in/G-ApproAPI/api"; 
export const API_ENDPOINTS ={

getLogin: () => `${baseUrl}/Login/login`,
getWarning: () => `${baseUrl}/Report/ApplicationWarning`,
getSmartReport: () => `${baseUrl}/Report/smartreport`,
getDropDownListAll: (category) => 
`${baseUrl}/ApprovalProcess/GetDropDownList/${category}`,
getApproverDropDownListAll: (search) => 
`${baseUrl}/ApprovalProcess/GetApproverDropDownList/${search}`,
getApproverDetails: (id) => 
`${baseUrl}/ApprovalProcess/GetApproverDetails/${id}`,
getBaseUrl: () => `${baseUrl}`,
InsertApprover: () => `${baseUrl}/ApprovalProcess/InsertApproval`,
UpdateApprover: () => `${baseUrl}/ApprovalProcess/InsertApprovalDetails`,
InsertSendToBankStatus: (id) => `${baseUrl}/ApprovalProcess/InsertSendToBankStatus/${id}`,
InsertRejectStatus: (id) => `${baseUrl}/ApprovalProcess/InsertRejectStatus/${id}`,
getDashboardCount: (type) => `${baseUrl}/Report/GetDashboardCountList/${type}`,
getDashboardReportDetails: (type) => `${baseUrl}/Report/GetDashboardDetailList/${type}`,
getPrintPreview: (lcnumber) => `${baseUrl}/Report/GetPrintPreview/${lcnumber}`,
InsertApproverAction: () => `${baseUrl}/ApprovalProcess/InsertApprovalAction`,
getApproverHistory: (id) => `${baseUrl}/Report/GetApproverHistory/${id}`,
DowanloadAttachment: (fileName) => 
`${baseUrl}/ApprovalProcess/download/${fileName}`,
PreviewAttachment: (fileName) => 
`${baseUrl}/ApprovalProcess/preview/${fileName}`,
deleteExistingAttachment: (fileName) => 
`${baseUrl}/ApprovalProcess/DeleteFile/${fileName}`,
ActionPreviewAttachment: (fileName,type) => 
`${baseUrl}/ApprovalProcess/actionpreview/${fileName}/${type}`,
getstatusReport: (lcNumber,statusId, pageNumber, pageSize,subjectTitle,
  lcApproval,requestedBy) =>
  `${baseUrl}/Report/GetStatusReportList/${lcNumber}/${statusId}/${pageNumber}/${pageSize}
  /${subjectTitle}/${lcApproval}/${requestedBy}`,

  gettatReport: (lcNumber,fromdate,todate,pageNumber,pageSize) =>
    `${baseUrl}/Report/GetTatReportList/${lcNumber}/${fromdate}/${todate}/${pageNumber}
    /${pageSize}`,
    getRequestDetails: (id) => 
`${baseUrl}/Report/GetRequestDetails/${id}`,
}